module.exports = __webpack_public_path__ + "static/img/portraitScreen.5a867a0d.png";